type Props = {
  value: number;
};

export const DueDaysCell = ({ value }: Props) => {
  if (value === 0) return '';
  return value;
};
